import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { PAGE_TITLES, ROUTES, PAGE_META_DESCRIPTION } from "../constants/appConstants";
import { useEffect } from "react";

const PageTitleManager = () => {
  const { pathname } = useLocation();

  const titleMap: any = {
    [ROUTES.HOME.path]: PAGE_TITLES.HOME,
    [ROUTES.ABOUT.path]: PAGE_TITLES.ABOUT,
    [ROUTES.CAREER.path]: PAGE_TITLES.CAREER,
    [ROUTES.CONTACT.path]: PAGE_TITLES.CONTACT,
    [ROUTES.POLICIES.path]: PAGE_TITLES.PRIVACY_POLICY,
    [ROUTES.TERMS_CONDITIONS.path]: PAGE_TITLES.TERMS_AND_CONDITIONS,
    [ROUTES.POLICY_SUBPAGE.path]: PAGE_TITLES.POLICY_SUBPAGE
  };

  const title = titleMap[pathname] || PAGE_TITLES.HOME;

  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={PAGE_META_DESCRIPTION.DEFAULT} />
    </Helmet>
  );
};

export default PageTitleManager;
